import styled from 'styled-components';


export const ContenedorPacientes = styled.div`
    width: 94%;
    margin: 1rem auto 2rem auto;
    display: flex;
    flex-direction: column;
`;


export const EncabezadoPacientes = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.2rem;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;


export const TabsPacientes = styled.div`
    display: flex;
    align-items: center;
    background-color: #f1f1ef;
    padding: 0.25rem;
    border-radius: 22px;
`;


export const BotonTabPaciente = styled.button`
    border: none;
    cursor: pointer;

    padding: 0.55rem 1.3rem;
    border-radius: 18px;

    font-size: 0.9rem;
    font-weight: 600;

    background-color: ${({ activo }) =>
        activo ? '#23AAAF' : 'transparent'};

    color: ${({ activo }) =>
        activo ? '#FFFFFF' : '#646464'};

    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ activo }) =>
            activo ? '#23AAAF' : '#E4F4F4'};
    }
`;


export const CantidadPacientes = styled.span`
    color: #646464;
    font-size: 0.85rem;
`;


export const EspacioFlexible = styled.div`
    flex: 1;
`;


export const BotonNuevoPaciente = styled.button`
    border: none;
    cursor: pointer;

    padding: 0.65rem 1.2rem;
    border-radius: 20px;

    background-color: #23AAAF;
    color: #FFFFFF;

    font-size: 0.9rem;
    font-weight: 600;

    transition: all 0.2s ease;

    &:hover {
        opacity: 0.88;
    }
`;


/* ---------------- FILTROS ---------------- */

export const ContenedorFiltros = styled.div`
    width: 100%;

    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex-wrap: wrap;

    margin-bottom: 1.4rem;
`;


export const CampoFiltro = styled.div`
    height: 42px;

    display: flex;
    align-items: center;

    border: 1px solid #DDDDD8;
    border-radius: 9px;

    background-color: #FFFFFF;

    padding: 0 0.8rem;

    min-width: ${({ ancho }) => ancho || '145px'};

    &:focus-within {
        border-color: #23AAAF;
    }
`;


export const InputFiltro = styled.input`
    width: 100%;
    height: 100%;

    border: none;
    outline: none;

    background-color: transparent;

    font-size: 0.9rem;
    color: #2B2B2B;

    &::placeholder {
        color: #646464;
    }
`;


export const SelectFiltro = styled.select`
    width: 100%;
    height: 100%;

    border: none;
    outline: none;

    cursor: pointer;

    background-color: transparent;

    font-size: 0.9rem;
    color: #2B2B2B;
`;


/* ---------------- TABLA ---------------- */

export const TablaContenedor = styled.div`
    width: 100%;
`;


export const EncabezadoTablaPacientes = styled.div`
    display: grid;

    grid-template-columns:
        minmax(200px, 1.6fr)
        minmax(150px, 1fr)
        minmax(150px, 1fr)
        minmax(90px, 0.5fr)
        55px;

    align-items: center;
    column-gap: 1rem;

    padding: 0 1rem 0.7rem 1rem;

    border-bottom: 1px solid #646464;

    @media (max-width: 850px) {
        grid-template-columns:
            minmax(180px, 1.5fr)
            minmax(130px, 1fr)
            minmax(80px, 0.5fr)
            50px;

        .columna-cobertura {
            display: none;
        }
    }

    @media (max-width: 600px) {
        grid-template-columns:
            1fr
            minmax(90px, auto)
            45px;

        .columna-servicio,
        .columna-cobertura {
            display: none;
        }
    }
`;


export const TituloColumna = styled.button`
    border: none;
    background: none;

    padding: 0;

    cursor: ${({ ordenable }) =>
        ordenable ? 'pointer' : 'default'};

    text-align: left;

    color: #646464;

    font-size: 0.75rem;
    font-weight: 700;

    text-transform: uppercase;
    letter-spacing: 0.03rem;
`;


export const FilaPacienteStyled = styled.div`
    position: relative;

    display: grid;

    grid-template-columns:
        minmax(200px, 1.6fr)
        minmax(150px, 1fr)
        minmax(150px, 1fr)
        minmax(90px, 0.5fr)
        55px;

    align-items: center;
    column-gap: 1rem;

    padding: 0.9rem 1rem;

    border-bottom: 1px solid #EDEDE9;

    background-color: ${({ indice }) =>
        indice % 2 === 0 ? '#FFFFFF' : '#FAFAF8'};

    cursor: pointer;

    transition: background-color 0.15s ease;

    &:hover {
        background-color: #F1F8F8;
    }

    &::before {
        content: '';

        position: absolute;

        left: 0;
        top: 20%;

        width: 3px;
        height: 60%;

        border-radius: 4px;

        background-color: ${({ servicio }) =>
            servicio === 'Método Yögen'
                ? '#23AAAF'
                : servicio === 'Apto para Método'
                ? '#FC8906'
                : '#646464'};
    }

    @media (max-width: 850px) {
        grid-template-columns:
            minmax(180px, 1.5fr)
            minmax(130px, 1fr)
            minmax(80px, 0.5fr)
            50px;

        .columna-cobertura {
            display: none;
        }
    }

    @media (max-width: 600px) {
        grid-template-columns:
            1fr
            minmax(90px, auto)
            45px;

        .columna-servicio,
        .columna-cobertura {
            display: none;
        }
    }
`;


export const NombrePaciente = styled.div`
    font-size: 0.95rem;
    font-weight: 700;
    color: #2B2B2B;
`;


export const TextoPaciente = styled.div`
    font-size: 0.88rem;
    color: #2B2B2B;
`;


export const EtiquetaServicio = styled.div`
    display: inline-flex;
    width: fit-content;

    align-items: center;

    padding: 0.35rem 0.7rem;
    border-radius: 15px;

    font-size: 0.78rem;
    font-weight: 600;

    background-color: ${({ servicio }) => {
        if (servicio === 'Método Yögen') {
            return '#DDF3F3';
        }

        if (servicio === 'Apto para Método') {
            return '#FFF0DE';
        }

        return '#EFEFEF';
    }};

    color: ${({ servicio }) => {
        if (servicio === 'Método Yögen') {
            return '#198C90';
        }

        if (servicio === 'Apto para Método') {
            return '#C86600';
        }

        return '#646464';
    }};
`;


export const BotonArchivar = styled.button`
    width: 36px;
    height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid #DDDDD8;
    border-radius: 50%;

    background-color: #FFFFFF;
    color: #646464;

    cursor: pointer;

    font-size: 1rem;

    transition: all 0.15s ease;

    &:hover {
        border-color: ${({ restaurar }) =>
            restaurar ? '#23AAAF' : '#FC8906'};

        color: ${({ restaurar }) =>
            restaurar ? '#23AAAF' : '#FC8906'};

        background-color: ${({ restaurar }) =>
            restaurar ? '#F1FAFA' : '#FFF7ED'};
    }
`;


/* ---------------- ESTADOS ---------------- */

export const SinResultados = styled.div`
    width: 100%;
    box-sizing: border-box;

    padding: 3rem 1rem;

    text-align: center;

    color: #646464;
    font-size: 0.95rem;
`;